/* eslint-disable import/prefer-default-export */
import React from "react";
import styled from "styled-components";

import { Md3Button } from "../../../../shared/components";
import { ModalShell } from "../../../../shared/components/ModalShell";
import type { MapActionOption } from "../../utils/poiContactLinks";

const Panel = styled.div`
  width: 100%;
  max-width: 420px;
  padding: 20px 20px 12px;
  border-radius: ${({ theme }) => theme.borderRadius.xl}px;
  background: ${({ theme }) => theme.colors.surface};
`;

const Title = styled.h2`
  margin: 0 0 4px;
  font-size: 24px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.text};
`;

const Description = styled.p`
  margin: 0 0 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

type MapActionSheetProps = {
  open: boolean;
  title: string;
  description?: string;
  options: MapActionOption[];
  onClose: () => void;
};

export function MapActionSheet({
  open,
  title,
  description,
  options,
  onClose,
}: MapActionSheetProps) {
  if (!open) return null;

  return (
    <ModalShell open={open} onClose={onClose} aria-label={title}>
      <Panel>
        <Title>{title}</Title>
        {description ? <Description>{description}</Description> : null}
        <Options>
          {options.map((option) => (
            <Md3Button
              key={option.id}
              title={option.label}
              variant="tonal"
              fullWidth
              onClick={() => {
                option.onPress();
                onClose();
              }}
            />
          ))}
          <Md3Button
            title="Cancelar"
            variant="text"
            fullWidth
            onClick={onClose}
          />
        </Options>
      </Panel>
    </ModalShell>
  );
}
